var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import styled from 'styled-components';
import { Redirect } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { parseContent } from '@ally/ally-md-parser';
import { Box, Button, Media, Space, Spinner, TextBody, } from '@ally/metronome-ui';
import { toCamelCase } from '@ally/utilitarian';
import { useTransmit } from '../../../../TransmitContext';
import { MultiConsent, useMultiConsentContext, } from './MultiConsent';
import { GettingInSvg } from '../../Svgs';
import { LoginHeading } from '../../Layout/Layout';
var StyledBox = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  justify-content: space-between;\n"])));
var StyledContentWrapped = styled(Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) { return "\n    ".concat(!props.isInPortal
    ? "props.media.up('lg')} {\n          width: ".concat((7 / 12) * 100, "%; // based on a 12 column grid\n        }")
    : '', "\n  "); });
var StyledSpinnerWrapper = styled(Box)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  justify-content: center;\n"], ["\n  width: 100%;\n  display: flex;\n  justify-content: center;\n"
    // svg right hand side
])));
// svg right hand side
var StyledSvgWrapper = styled(Box)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var media = _a.theme.media;
    return "\n    ".concat(media.up('lg'), " {\n      width: ").concat((4 / 12) * 100, "%; // based on a 12 column grid\n      order: 1;\n    }\n  ");
});
var ConsentContent = function (_a) {
    var onComplete = _a.onComplete, status = _a.status, jsonBodies = _a.jsonBodies, jsonButton = _a.jsonButton, shouldFocusOnMount = _a.shouldFocusOnMount, consentType = _a.consentType;
    var multiConsentContext = useMultiConsentContext();
    var handleOnClick = function () {
        // If there is only one Consent
        if (!multiConsentContext) {
            onComplete();
        }
        else {
            multiConsentContext === null || multiConsentContext === void 0 ? void 0 : multiConsentContext.showNextConsent();
        }
    };
    var ConsentBodies = jsonBodies.map(function (body, index) {
        return (React.createElement(Space, { mb: "sm", key: uuidv4() },
            React.createElement(TextBody, __assign({ tag: "p", size: "sm", "data-testid": "secure-consent-body_".concat(index), 
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                dangerouslySetInnerHTML: { __html: parseContent(body) } }, (shouldFocusOnMount && index === 0 ? { focusOnMount: true } : {})))));
    });
    return (React.createElement(Box, null,
        ConsentBodies,
        jsonButton && (React.createElement(Button, { text: jsonButton, onClick: handleOnClick, loading: status === 'Loading', "data-testid": "secure-consent-button", allytmln: "".concat(consentType, "-").concat(toCamelCase(jsonButton)) }))));
};
export var SecureConsentForm = function (_a) {
    var onComplete = _a.onComplete, status = _a.status, error = _a.error, _b = _a.consents, consents = _b === void 0 ? [] : _b;
    var isInPortal = useTransmit().isInPortal;
    var _c = __read(React.useState([]), 2), loadedConsents = _c[0], setLoadedConsents = _c[1];
    // load all esigns before rendering
    React.useEffect(function () {
        var promises = consents.map(function (_a) {
            var contentUrl = _a.contentUrl, title = _a.title, consentType = _a.consentType;
            return fetch(contentUrl)
                .then(function (res) { return res.json(); })
                .then(function (data) { return (__assign(__assign({}, data), { title: title, consentType: consentType })); })
                .catch(function (err) {
                /* istanbul ignore next */
                throw err;
            });
        });
        Promise.all(promises)
            .then(function (results) {
            var shouldFocusOnMount = results.length === 1;
            var mappedConsents = results.map(function (result, idx) {
                var body = result.body, cta = result.cta, title = result.title, consentType = result.consentType;
                return {
                    title: title,
                    component: (React.createElement(ConsentContent, { consentType: consentType, key: uuidv4(), onComplete: onComplete, status: status, jsonBodies: body, jsonButton: cta, shouldFocusOnMount: shouldFocusOnMount })),
                };
            });
            setLoadedConsents(mappedConsents);
        })
            .catch(function (reason) {
            // If the consents fail to load we send the user to the
            // temporarily unavailable screen
            setLoadedConsents([
                {
                    title: 'Error',
                    component: React.createElement(Redirect, { to: "/temp-unavailable" }),
                },
            ]);
        });
    }, []);
    var hostServices = useTransmit().hostServices;
    React.useEffect(function () {
        hostServices === null || hostServices === void 0 ? void 0 : hostServices.analytics.trackPageView({
            eventType: 'pageview',
            pageName: 'AOS:Login:Electronic Consent and Terms of Use',
        });
    }, []);
    if (consents && consents.length === 0) {
        return React.createElement(Redirect, { to: "/temp-unavailable" });
    }
    return (React.createElement(StyledBox, null,
        React.createElement(StyledContentWrapped, { isInPortal: isInPortal },
            React.createElement(LoginHeading, { title: "Electronic Consent and Terms of Use" }),
            loadedConsents.length >= 1 ? (React.createElement(React.Fragment, null,
                React.createElement(Box, { mb: "md" },
                    React.createElement(TextBody, { size: "sm", tag: "p", "data-testid": "secure-consent-lead-copy" }, "Almost there. Before we finish, we just need you to agree to our Electronic Consent and Terms of Use.")),
                React.createElement(MultiConsent, { consents: loadedConsents, onComplete: onComplete }))) : (React.createElement(StyledSpinnerWrapper, null,
                React.createElement(Spinner, null)))),
        !isInPortal && (React.createElement(StyledSvgWrapper, { "data-testid": "getting-in-image" },
            React.createElement(Media.LgUp, null,
                React.createElement(GettingInSvg, null))))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=SecureConsentForm.js.map